<dynamic-form
  *ngIf="columns && columns.length > 0"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="save()"
  (onRowSelected)="onChange($event)">
</dynamic-form>
